/* Satora: product gallery arrows. Always visible, hidden at each end. */
(function () {
  'use strict';
  if (window.__satoraGalleryArrows) return;
  window.__satoraGalleryArrows = true;

  var EDGE = 4;

  function isProductGallery(comp) {
    if (comp.querySelector('[class*="product-media"]')) return true;
    return !!comp.closest('[id*="media-gallery"], [class*="product-media"]');
  }

  function update(comp) {
    var slides = comp.querySelector('slideshow-slides');
    if (!slides) return;
    var max = slides.scrollWidth - slides.clientWidth;
    var pos = Math.abs(slides.scrollLeft);
    var single = max <= EDGE;
    comp.classList.toggle('sat-gal--single', single);
    comp.classList.toggle('sat-gal--start', !single && pos <= EDGE);
    comp.classList.toggle('sat-gal--end', !single && pos >= max - EDGE);
  }

  function attach(comp) {
    if (comp.dataset.satGal === '1') return;
    if (!isProductGallery(comp)) return;
    var slides = comp.querySelector('slideshow-slides');
    if (!slides) return;

    comp.dataset.satGal = '1';
    comp.classList.add('sat-gal');

    var raf = 0;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(comp); });
    }

    slides.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    if ('ResizeObserver' in window) {
      try { new ResizeObserver(schedule).observe(slides); } catch (e) {}
    }
    if ('MutationObserver' in window) {
      try { new MutationObserver(schedule).observe(slides, { childList: true }); } catch (e) {}
    }

    update(comp);
    setTimeout(function () { update(comp); }, 400);
  }

  function scan() {
    var list = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < list.length; i++) attach(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();
